package dev.wyns.ventrova.ui.theme

import androidx.compose.ui.graphics.Color

/** Design tokens shared by all platforms (converted from the design's oklch values). */
object VentrovaColors {
    val Ink = Color(0xFF1C1F1A)
    val InkHover = Color(0xFF33372F)
    val Body = Color(0xFF2E312B)
    val Secondary = Color(0xFF5E6159)
    val Muted = Color(0xFF7A7D74)
    val Subtle = Color(0xFF8A8C84)
    val Faint = Color(0xFFA3A59E)
    val Chevron = Color(0xFFC4C1B8)

    val MapBackground = Color(0xFFE9E6DE)
    val Paper = Color(0xFFFBFAF7)
    val Canvas = Color(0xFFF7F5EF)
    val Grouped = Color(0xFFF2F1EC)
    val Page = Color(0xFFF6F4EF)
    val Sand = Color(0xFFEFEDE6)
    val SandLight = Color(0xFFF1EFE8)
    val SandDark = Color(0xFFECE9E1)
    val Line = Color(0xFFE3E0D8)
    val LineStrong = Color(0xFFDEDBD2)
    val Outline = Color(0xFFC4C1B8)
    val OutlineStrong = Color(0xFF8A8C84)
    val Hairline = Color(0x141C1F1A)
    val StripeWarm = Color(0xFFF9F5EC)
    val StarEmpty = Color(0xFFDAD6CC)

    val Accent = Color(0xFF236436)
    val AccentDark = Color(0xFF115629)
    val AccentContainer = Color(0xFFC3EAC9)
    val AccentContainerSoft = Color(0xFFD7EBDA)
    val AccentContainerLight = Color(0xFFD6F0DA)
    val OnAccentContainer = Color(0xFF003311)
    val OnAccentContainerAlt = Color(0xFF033816)
    val NavIndicator = Color(0xFFC8E8CD)
    val TabActive = Color(0xFF195C2E)

    val Link = Color(0xFF195C2E)

    val Open = Color(0xFF21763C)
    val Closed = Color(0xFFAB4235)
    val Star = Color(0xFFE49E22)
    val Favorite = Color(0xFFD33949)
    val Error = Color(0xFFB2392B)
    val ErrorAndroid = Color(0xFFB3261E)
    val SwitchOnIos = Color(0xFF34C759)
    val SwitchOff = Color(0xFFE3E1DB)

    /** Fry oil block of a chip shop that fries in animal fat. */
    val AnimalFatSoft = Color(0xFFFFE8E3)
    val AnimalFatInk = Color(0xFF822D22)

    val LocationIos = Color(0xFF2F7BF6)
    val LocationAndroid = Color(0xFF1A73E8)

    /** Grey used for closed places on the map. */
    val ClosedMarker = Color(0xFF9C9E97)
    val MarkerRingEmpty = Color(0xFFCFCBC1)
    val MarkerRingEmptyAlt = Color(0xFFF4F2EC)

    /** Part of a menu ring that is neither vegan nor vegetarian. */
    val MenuRingTrack = Color(0xFFE6E2D8)
}

/** Colors that identify a vegan level everywhere in the UI. */
data class LevelPalette(
    /** Strong color: glyphs, marker icons. */
    val color: Color,
    /** Soft background: badges, thumbnails. */
    val soft: Color,
    /** Text on [soft]. */
    val ink: Color,
)

object LevelPalettes {
    val Vegan = LevelPalette(color = Color(0xFF36884D), soft = Color(0xFFDFF6E2), ink = Color(0xFF114320))
    val Vegetarian = LevelPalette(color = Color(0xFF946D00), soft = Color(0xFFF9EDD5), ink = Color(0xFF503900))
    val VeganOptions = LevelPalette(color = Color(0xFF4974BA), soft = Color(0xFFE3EFFF), ink = Color(0xFF233C67))
}
